import enUS from './en-US.json';
import esES from './es-ES.json';
import ptBR from './pt-BR.json';
const translations = {
    'en-US': enUS,
    'es-ES': esES,
    'pt-BR': ptBR,
};
export default translations;
